export enum CardVariant {
    PRIMARY,
    SECONDARY,
    TERTIARY
}
